import stylesheet0 from "@oneappexchange/appx-font-utilities";
import stylesheet1 from "@oneappexchange/appx-reset";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".empty-state-image" + shadowSelector + " {--axds-ovr-image-background: transparent;}.label" + shadowSelector + " {font-weight: 600;padding-top: var(--sds-g-spacing-5);text-align: center;}.description" + shadowSelector + " {margin: var(--sds-g-spacing-2) 0 0;color: var(--sds-g-color-palette-neutral-30);text-align: center;}.container" + shadowSelector + " {display: flex;flex-direction: column;align-items: center;}wds-button" + shadowSelector + " {padding-top: var(--sds-g-spacing-5);}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet1, stylesheet];